import { render, staticRenderFns } from "./loanManage.vue?vue&type=template&id=8c45838a&scoped=true&"
import script from "./loanManage.vue?vue&type=script&lang=js&"
export * from "./loanManage.vue?vue&type=script&lang=js&"
import style0 from "./loanManage.vue?vue&type=style&index=0&id=8c45838a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c45838a",
  null
  
)

export default component.exports